import { Body2 } from "@ui/components/text/Body2";
import { ColorClass } from "@ui/types/enums/ColorClass";
import { PlainButton } from "@ui/components/buttons/PlainButton";
import { joinClasses } from "@ui/utils/joinClasses";
import styles from "@ui/components/bottom-tabs/css/BottomTabButton.module.css";
import { useRouter } from "next/router";
import Link from "next/link";

export function BottomTabButton({
  children,
  className,
  href,
  icon,
}: {
  children: any;
  className?: string;
  href: string;
  icon: JSX.Element;
}): JSX.Element {
  const router = useRouter();
  const isActive = router.asPath.includes(href);

  return (
    <Link className={styles.link} href={href}>
      <PlainButton
        className={joinClasses(
          styles.tabButton,
          isActive ? styles.tabButtonActive : null,
          className
        )}
      >
        {icon}
        <Body2
          colorClass={isActive ? ColorClass.Primary : ColorClass.Secondary}
          className={styles.tabButtonText}
        >
          {children}
        </Body2>
      </PlainButton>
    </Link>
  );
}
